const imageUpload = async() => {
    const URL = await fetch('https://getuplurl.playwithbot.com/image/GetUplURL/v1', {
        method: 'POST',
    })

    return URL.headers.get('location')
}

export default imageUpload